export const snagCategories = [
  "Civil",
  "Electrical",
  "Plumbing",
  "HVAC",
  "Finishing",
  "Painting",
  "Carpentry",
  "Flooring",
  "Glazing",
  "Waterproofing",
  "Fire Safety",
  "Other",
];

export const snagSubcategories = {
  Civil: ["Crack", "Alignment", "Level", "Plastering", "Structural"],
  Electrical: ["Wiring", "Switchboard", "Earthing", "Lighting", "DB Panel"],
  Plumbing: [
    "Leakage",
    "Drainage",
    "Fixture",
    "Pipe Alignment",
    "Water Supply",
  ],
  HVAC: ["Duct", "AC Unit", "Ventilation", "Thermostat"],
  Finishing: ["Surface", "Edge", "Joint", "Sealant"],
  Painting: ["Patch", "Color Mismatch", "Peeling", "Stain"],
  Carpentry: ["Warping", "Fitting", "Hinge", "Lock"],
  Flooring: ["Tile Crack", "Level", "Grout", "Chip"],
  Glazing: ["Scratch", "Seal", "Alignment", "Breakage"],
  Waterproofing: ["Seepage", "Membrane", "Coating"],
  "Fire Safety": ["Sprinkler", "Alarm", "Extinguisher", "Exit Sign"],
  Other: ["General", "Miscellaneous"],
};

export const mockProjects = [
  "Skyline Residences",
  "Green Valley Villas",
  "Metro Business Park",
  "Lakefront Towers",
  "Sunrise Heights",
];

const activities = [
  {
    id: "a1",
    type: "created",
    user: "Amit Sharma",
    avatar: "AS",
    timestamp: "2026-03-28 09:15",
    text: "Created snag and uploaded issue photo",
  },
  {
    id: "a2",
    type: "assigned",
    user: "Amit Sharma",
    avatar: "AS",
    timestamp: "2026-03-28 09:20",
    text: "Assigned to Rajesh Kumar with expected closure 04 Apr",
  },
  {
    id: "a3",
    type: "accepted",
    user: "Rajesh Kumar",
    avatar: "RK",
    timestamp: "2026-03-28 14:00",
    text: "Accepted assignment, committed closure by 03 Apr",
  },
  {
    id: "a4",
    type: "attachment",
    user: "Rajesh Kumar",
    avatar: "RK",
    timestamp: "2026-04-01 11:30",
    text: "Uploaded fix image for approval",
    attachments: [
      {
        id: "att1",
        name: "fix-photo.jpg",
        url: "#",
        type: "image",
        status: "approval",
        uploadedBy: "Rajesh Kumar",
        uploadedAt: "2026-04-01 11:30",
      },
    ],
  },
  {
    id: "a5",
    type: "approval_requested",
    user: "Rajesh Kumar",
    avatar: "RK",
    timestamp: "2026-04-01 11:32",
    text: "Requested approval from Amit Sharma",
  },
];

export const mockSnags = [
  {
    id: "s1",
    code: "SNG-001",
    title: "Wall crack in living room - Unit 302",
    description: "Visible hairline crack on north wall of living room.",
    project: "Skyline Residences",
    location: "Tower A",
    floor: "3rd Floor",
    unit: "302",
    category: "Civil",
    subcategory: "Crack",
    priority: "High",
    status: "Pending Approval",
    createdBy: "Amit Sharma",
    createdAt: "2026-03-28",
    assignedTo: ["Rajesh Kumar"],
    approver: "Amit Sharma",
    expectedClosure: "2026-04-04",
    committedDate: "2026-04-03",
    lastActivity: "2026-04-01",
    tags: ["structural", "urgent"],
    image: "/placeholder.svg",
    attachments: [
      {
        id: "att0",
        name: "issue-photo.jpg",
        url: "#",
        type: "image",
        status: "initial",
        uploadedBy: "Amit Sharma",
        uploadedAt: "2026-03-28",
      },
    ],
    activities: [...activities],
    comments: [],
  },
  {
    id: "s2",
    code: "SNG-002",
    title: "Electrical panel misaligned - Unit 501",
    description: "DB panel cover is not flush with wall finish.",
    project: "Skyline Residences",
    location: "Tower B",
    floor: "5th Floor",
    unit: "501",
    category: "Electrical",
    subcategory: "DB Panel",
    priority: "Medium",
    status: "Open",
    createdBy: "Priya Patel",
    createdAt: "2026-03-30",
    assignedTo: ["Suresh Nair"],
    approver: "Priya Patel",
    expectedClosure: "2026-04-07",
    committedDate: "2026-04-06",
    lastActivity: "2026-03-30",
    tags: ["electrical"],
    image: "/placeholder.svg",
    attachments: [],
    activities: [
      {
        id: "s2-a1",
        type: "created",
        user: "Priya Patel",
        timestamp: "2026-03-30 10:00",
        text: "Created snag",
      },
    ],
    comments: [],
  },
  {
    id: "s3",
    code: "SNG-003",
    title: "Bathroom seepage near shower area",
    description: "Water seepage marks visible on wall below tile joint.",
    project: "Green Valley Villas",
    location: "Villa C-12",
    floor: "Ground Floor",
    unit: "C-12",
    category: "Waterproofing",
    subcategory: "Seepage",
    priority: "Critical",
    status: "Issue Raised",
    createdBy: "Neha Iyer",
    createdAt: "2026-04-02",
    assignedTo: ["Deepak Joshi", "Manoj Verma"],
    approver: "Neha Iyer",
    expectedClosure: "2026-04-09",
    committedDate: "2026-04-08",
    lastActivity: "2026-04-05",
    tags: ["seepage", "rework"],
    image: "/placeholder.svg",
    attachments: [],
    activities: [
      {
        id: "s3-a1",
        type: "created",
        user: "Neha Iyer",
        timestamp: "2026-04-02 12:10",
        text: "Created snag",
      },
      {
        id: "s3-a2",
        type: "issue_raised",
        user: "Deepak Joshi",
        timestamp: "2026-04-05 09:40",
        text: "Raised issue after initial fix failed water test",
      },
    ],
    comments: [],
  },
];
